import { render, staticRenderFns } from "./SendView.vue?vue&type=template&id=39a9133c&"
import script from "./SendView.vue?vue&type=script&lang=js&"
export * from "./SendView.vue?vue&type=script&lang=js&"
import style0 from "./SendView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports